/**
 * @zelari/core/verification — deterministic evidence contract + optional
 * LLM VerifierService (ADR-0023).
 */
export * from './types.js';
export * from './engine.js';
export * from './completionPolicy.js';
export * from './sessionEvidence.js';
export * from './criteriaPack.v1.js';
export * from './metrics.js';
export * from './verifier.js';
export * from './scopeDiscipline.js';
export * from './resourceReserveGate.js';
